/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    EndorsementPageHeader: {
        id: 'cep.components.sgEndorsementQuotePage.Header',
        defaultMessage: 'Summary & Purchase'
    },
    ChangeEffective: {
        id: 'cep.components.sgEndorsementQuotePage.ChangeEffective',
        defaultMessage: 'Your changes below will become effective from {date}.'
    },
    ReviewChanges: {
        id: 'cep.components.sgEndorsementQuotePage.ReviewChanges',
        defaultMessage: 'Please review your changes and continue.'
    },
    ComprehensiveCoverLabel: {
        id: 'cep.components.sgEndorsementQuotePage.ComprehensiveCoverLabel',
        defaultMessage: 'At Saga we have 3 Comprehensive cover levels that can be tailored to suit your needs and budget: Standard, Select and Plus. If you\'d like to discuss the different options call us on {phoneNumber1} and we will help you find the cover that is right for you.'
    },
    ContinueLabel: {
        id: 'cep.components.sgEndorsementQuotePage.ContinueLabel',
        defaultMessage: 'Continue'
    },
    GoBackLabel: {
        id: 'cep.components.sgEndorsementQuotePage.GoBackLabel',
        defaultMessage: 'Back'
    },
    CancelAllChanges: {
        id: 'cep.components.sgEndorsementQuotePage.CancelAllChanges',
        defaultMessage: 'Cancel all changes'
    }
});
